import React from 'react';
import { Star } from 'lucide-react';

export const Stars = ({ rating = 0, size = 'w-4 h-4' }) => (
  <div className="flex space-x-0.5" aria-label={`${rating} out of 5 stars`}>
    {[0, 1, 2, 3, 4].map((i) => (
      <Star key={i} className={`${size} ${i < Math.round(rating) ? 'fill-gold-400 text-gold-400' : 'text-gray-300'}`} />
    ))}
  </div>
);

const Avatar = ({ review }) => (
  review.photo ? (
    <img src={review.photo} alt="" className="w-14 h-14 rounded-full object-cover" referrerPolicy="no-referrer" />
  ) : (
    <div className="w-14 h-14 rounded-full bg-gradient-to-br from-blue-400 to-cyan-400 flex items-center justify-center font-bold text-white text-xl">
      {(review.author || 'G').charAt(0)}
    </div>
  )
);

export const ReviewCard = ({ review }) => (
  <div className="bg-white rounded-2xl p-8 sm:p-10 shadow-xl border border-gray-100 mx-auto max-w-2xl text-center min-h-[18rem] flex flex-col justify-center">
    <div className="flex items-center justify-center space-x-3 mb-4">
      <Avatar review={review} />
      <div className="text-left">
        {review.authorUri ? (
          <a href={review.authorUri} target="_blank" rel="noopener noreferrer" className="font-bold text-[#143160] hover:underline">{review.author}</a>
        ) : (
          <span className="font-bold text-[#143160]">{review.author}</span>
        )}
        <div className="flex items-center space-x-2">
          <Stars rating={review.rating} />
          <span className="text-xs text-gray-400">{review.relativeTime}</span>
        </div>
      </div>
    </div>
    <p className="text-gray-700 leading-relaxed italic">&ldquo;{review.text}&rdquo;</p>
    {review.googleMapsUri && (
      <a href={review.googleMapsUri} target="_blank" rel="noopener noreferrer" className="mt-5 text-xs font-semibold text-blue-600 hover:underline">
        View on Google Maps
      </a>
    )}
  </div>
);
